import React, { useState, ChangeEvent } from 'react'
import { ReactMic } from 'react-mic';
import { FaMicrophone, FaStop } from 'react-icons/fa';
import TextareaEditor from '../../components/Form/TextareaEditor'
import './styles.css'

import { transcriptAudio } from '../../services/AudioTranscript';

interface typeProps {
  title: string,
  name: string;
  data: string;
  setData: Function;
}

export default function RecordMic({
  title,
  name,
  data,
  setData
}: typeProps) {

  const [record, setRecord] = useState<boolean>(false);
  const [show, setShow] = useState(false)

  const startRecording = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    Promise.resolve(setShow(true)).then(() => setRecord(true))
      ;
  }

  const stopRecording = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    Promise.resolve(setRecord(false)).then(() => setShow(false))
      ;
  }

  const onData = (recordedBlob: any) => {
    //console.log('chunk of real-time data is: ', recordedBlob);
  }

  const onStop = (recordedBlob: any) => {
    //console.log('recordedBlob is: ', recordedBlob?.blob);
    transcriptAudio(recordedBlob?.blob).then((res: any) => {
      if (res?.data) {
        setData(res.data.message || '')
      }
    })
  }

  return (

    <div className="field">
      <label htmlFor="label">{title}:</label>

      <TextareaEditor
        name={name}
        label={title}
        placeholder={title}
        data={data}
        setData={(value: string) => { setData(value) }}
      />

      <div className="d-flex justify-content-end align-items-center">
        {show && <ReactMic
          record={record}
          onStop={onStop}
          onData={onData}
          className={'audio'}
          mimeType='audio/wav'
          channelCount={2}
          strokeColor="#F5A201" />}

        {!record ?
          <button onClick={(event: any) => startRecording(event)} className="btn btn-primary d-flex record ">
            <FaMicrophone /> Gravar
        </button>
          :
          <button onClick={(event: any) => stopRecording(event)} className="btn btn-secundary d-flex record">
            <FaStop /> Parar
      </button>
        }
      </div>
    </div>

  )
}

